import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AssessmentNewPage } from 'src/pages/Assessments/AssessmentNewPage';
import AssessmentsLayout from 'src/pages/Assessments/AssessmentsLayout';

/**
 * Routes for trainer assessments
 * These routes are accessible under /trainer/assessments/
 */
const AssessmentsRoutes: FC = () => {
  return (
    <Routes>
      <Route index element={<AssessmentsLayout />} />
      <Route path="leads" element={<AssessmentsLayout tabName="leads" />} />
      <Route path="sequences" element={<AssessmentsLayout tabName="sequences" />} />
      <Route path="completed" element={<AssessmentsLayout tabName="completed" />} />
      <Route path="new" element={<AssessmentNewPage />} />
      <Route path=":assessmentId" element={<AssessmentNewPage />} />
    </Routes>
  );
};

export default AssessmentsRoutes;
